import React, { FC } from 'react'
import { BaseFacetProps } from '../types'
import { updateClientSideUrl } from '../helpers/url'
import GeoLocationConnector, { ConnectorProps as GeoLocationProps } from 'connectors/GeoLocation'
import SortConnector, { ConnectorProps as SortConnectorProps } from 'connectors/Algolia/Sort'
import RadioListFacet from '../components/RadioListFacet'
import { getSortOptionsByZone } from 'apps/public/browse/helpers'

type SortFacetProps = BaseFacetProps &
  GeoLocationProps &
  SortConnectorProps & {
    onFilterCallback?: (hrefParam: string) => void
  }

const SortFacet: FC<SortFacetProps> = ({
  baseUrl,
  nextAppRoute,
  onFilterCallback,
  sort,
  geoLocation,
  getHref,
}) => {
  const { destinationZone } = geoLocation

  const handleSortingClick = (hrefParam: string) => {
    updateClientSideUrl(hrefParam, nextAppRoute)
    onFilterCallback?.(hrefParam)
  }

  const geoSortOptions = getSortOptionsByZone(destinationZone)

  const filterOptions = geoSortOptions.map(({ title, value }) => {
    const isSelected = value === sort

    const href = getHref({
      ['sort']: isSelected ? '' : value,
      page: '', // Reset Page
    })
    const newUrlPath = `${baseUrl}${href}`

    return {
      text: title,
      selected: isSelected,
      onClick: () => handleSortingClick(newUrlPath),
      href: newUrlPath,
    }
  })

  return <RadioListFacet facetName='sort' filterOptions={filterOptions} />
}

export default SortConnector(GeoLocationConnector(SortFacet))
